/**
 * Created by wiki on 2017/2/27.
 */
import Vuex from 'vuex'
import Vue from 'vue'
import {actions,mutations}from './actions'
import * as getters from './getters'

Vue.use(Vuex);

const state = {
  appid:null,
  stores:[],
  userwx:{'nickname':"as"},
  gatewaytype:[],
  gatewayversion:[],
  nodetype:[],
  addmeauDataOnline: [],
  addmeauDataOpen: [],
  nameTabs:'',
  searchNumber:'',
  warranty:[],
  addmeauDataOnlineRes:0,
  addmeauDataOpenRes:0,
  resl:0,
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
})



// WEBPACK FOOTER //
// ./src/store/index.js